'use client';

import React from 'react';
import Link from 'next/link';
import Header from '@/components/Header';

const aboutSections = [
  { id: 'about', label: 'About Us', href: '/about' },
  { id: 'history', label: 'History', href: '/about/history' },
  { id: 'mission', label: 'Mission', href: '/about/mission' },
  { id: 'vision', label: 'Vision', href: '/about/vision' },
  { id: 'membership', label: 'Membership', href: '/about/membership' },
  { id: 'quality', label: 'Quality Management', href: '/about/quality-management' },
  { id: 'ethics', label: 'Business Ethics', href: '/about/business-ethics' },
];

const memberships = [
  { name: 'IATA', fullName: 'International Air Transport Association', detail: 'IATA number 09-4 7102 / 0016', color: '#60A5FA' },
  { name: 'All World Shipping / World Cargo Alliance', fullName: 'World\'s largest and most powerful network of independent freight forwarders', detail: '', color: '#34D399' },
  { name: 'FIATA', fullName: 'International Federation of Freight Forwarders Associations', detail: '', color: '#818CF8' },
  { name: 'Security Cargo Network (SCN)', fullName: 'Global alliance of independent international freight forwarders', detail: '', color: '#F59E0B' },
  { name: 'AMCHAM', fullName: 'American Chamber of Commerce in Bulgaria', detail: '', color: '#F87171' },
  { name: 'Pangea Logistics Network', fullName: 'International Freight Network of First Class independent Freight Forwarders', detail: '', color: '#A78BFA' },
  { name: 'NSBS', fullName: 'Bulgarian Association for Freight Forwarding, Transport and Logistics', detail: '', color: '#38BDF8' },
  { name: 'UN Global Compact', fullName: 'United Nations Global Compact', detail: 'Strategic policy initiative for businesses committed to aligning their operations and strategies with ten universally accepted principles in the areas of human rights, labour, environment and anti-corruption.', color: '#4ADE80' },
  { name: 'Marco Polo Line Network', fullName: 'Independent Freight Forwarders Network', detail: '', color: '#FB923C' },
  { name: 'Twig Logistics Network', fullName: 'Twig Logistics Network', detail: 'A group that gathers the most reliable independent freight forwarders worldwide. Combining innovation, full global coverage and top-class agents.', color: '#E879F9' },
  { name: 'JC Trans', fullName: 'International Freight Forwarders Network', detail: 'A leading international logistics B2B platform with a global community of 10,000+ paid members.', color: '#2DD4BF' },
];

export default function MembershipPage() {
  return (
    <>
      <Header />
      <main className="min-h-screen" style={{ background: '#F4F6F9', color: '#0F2340' }}>
        {/* Hero */}
        <div className="relative pt-32 pb-16 px-6" style={{ background: 'linear-gradient(180deg, #0F2340 0%, #1A3558 100%)', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div className="max-w-5xl mx-auto">
            <Link href="/about" className="inline-flex items-center gap-2 text-sm font-body mb-4 transition-colors" style={{ color: '#7EB8F7' }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#FFFFFF'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#7EB8F7'}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 5l-7 7 7 7" /></svg>
              The Company
            </Link>
            <p className="text-xs uppercase tracking-widest font-body mb-3" style={{ color: '#7EB8F7' }}>World Transport Overseas</p>
            <h1 className="text-4xl lg:text-5xl font-bold font-body mb-4" style={{ color: '#FFFFFF' }}>Membership</h1>
            <p className="text-lg font-body max-w-2xl" style={{ color: 'rgba(200,216,240,0.7)' }}>
              WTO is a proud member of the world's leading freight forwarding and logistics associations.
            </p>
          </div>
        </div>

        {/* Sub-nav */}
        <div className="sticky top-20 z-30 px-6 py-3" style={{ background: 'rgba(255,255,255,0.97)', borderBottom: '1px solid rgba(15,35,64,0.1)', backdropFilter: 'blur(12px)' }}>
          <div className="max-w-5xl mx-auto flex flex-wrap gap-1">
            {aboutSections.map((s) => (
              <Link key={s.id} href={s.href}
                className="px-4 py-2 rounded-full text-sm font-body font-medium transition-all duration-200"
                style={s.id === 'membership'
                  ? { background: '#1B6B8A', color: '#FFFFFF', border: '1px solid rgba(27,107,138,0.5)' }
                  : { background: 'transparent', color: '#3A5070', border: '1px solid rgba(15,35,64,0.15)' }}
                onMouseEnter={(e) => { if (s.id !== 'membership') { e.currentTarget.style.background = 'rgba(27,107,138,0.1)'; e.currentTarget.style.color = '#0F2340'; } }}
                onMouseLeave={(e) => { if (s.id !== 'membership') { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#3A5070'; } }}
              >{s.label}</Link>
            ))}
          </div>
        </div>

        {/* Content */}
        <div className="max-w-5xl mx-auto px-6 py-16">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {memberships.map((m) => (
              <div key={m.name} className="rounded-2xl p-6 transition-all duration-300"
                style={{ background: '#FFFFFF', border: '1px solid rgba(15,35,64,0.1)', boxShadow: '0 2px 8px rgba(15,35,64,0.06)' }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLDivElement).style.background = `${m.color}10`; (e.currentTarget as HTMLDivElement).style.borderColor = `${m.color}40`; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLDivElement).style.background = '#FFFFFF'; (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(15,35,64,0.1)'; }}>
                <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-4" style={{ background: `${m.color}20`, border: `1px solid ${m.color}40` }}>
                  <div className="w-3 h-3 rounded-full" style={{ background: m.color }} />
                </div>
                <h3 className="text-base font-bold font-body mb-1" style={{ color: '#0F2340' }}>{m.name}</h3>
                <p className="text-sm font-body mb-2" style={{ color: m.color }}>{m.fullName}</p>
                {m.detail && <p className="text-xs font-body leading-relaxed" style={{ color: '#6A85A0' }}>{m.detail}</p>}
              </div>
            ))}
          </div>
        </div>
      </main>
    </>
  );
}
